export default "__VITE_ASSET__7dww1A1E__"